<template lang="pug">
.container
  .rankBadge(
    v-if="!position && position > 0 && points >= 0 && (rank !== 'unranked' || !mini)"
    :class="{ mini, unranked: rank === 'unranked' }"
  )
    img.rankBadge-image(v-if="rank !== 'unranked'" :src="image.src" :key="image.src")
    span.rankBadge-points(v-if="!mini") {{ points.toString().replace('.', ',') }} pontos
  .badge-for-ranking(v-else-if="position <= 3 && position > 0")
    img.rankBadge-image(:src="imageForRanking" :key="imageForRanking")
</template>

<script>
export default {
  name: 'RankBadge',
  props: {
    points: {
      type: Number,
      default: 0,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    jobTitle: {
      type: String,
      default: 'Vendedor',
    },
    isGame: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    rank() {
      return this.isGame ? this.rankGame : this.rankPerformance
    },
    rankGame() {
      const ranks = {
        Vendedor: [
          ['diamond', 2160],
          ['gold', 1800],
          ['silver', 1440],
          ['bronze', 1],
          ['unranked', 0],
        ],
        Coordenador: [
          ['diamond', 2040],
          ['gold', 1800],
          ['silver', 1440],
          ['bronze', 1],
          ['unranked', 0],
        ],
        Gerente: [
          ['diamond', 1428],
          ['gold', 1260],
          ['silver', 1008],
          ['bronze', 1],
          ['unranked', 0],
        ],
        Empresa: [
          ['diamond', 1428],
          ['gold', 1260],
          ['silver', 1008],
          ['bronze', 1],
          ['unranked', 0],
        ],
      }
      const { points, jobTitle } = this
      return ranks[jobTitle]?.find(rank => rank[1] <= points)[0]
    },
    rankPerformance() {
      const ranks = {
        Vendedor: [
          ['diamond', 9],
          ['gold', 8],
          ['silver', 7],
          ['bronze', 6],
          ['unranked', 0],
        ],
        Coordenador: [
          ['diamond', 9],
          ['gold', 8],
          ['silver', 7],
          ['bronze', 6],
          ['unranked', 0],
        ],
        Gerente: [
          ['diamond', 9],
          ['gold', 8],
          ['silver', 7],
          ['bronze', 6],
          ['unranked', 0],
        ],
        Empresa: [
          ['diamond', 9],
          ['gold', 8],
          ['silver', 7],
          ['bronze', 6],
          ['unranked', 0],
        ],
      }
      const { points, jobTitle } = this
      return ranks[jobTitle]?.find(rank => rank[1] <= points)[0]
    },
    image() {
      const { rank } = this
      const images = {
        diamond: { src: '/images/rank-diamond.svg', name: 'Diamante' },
        gold: { src: '/images/rank-gold.svg', name: 'Ouro' },
        silver: { src: '/images/rank-silver.svg', name: 'Prata' },
        bronze: { src: '/images/rank-bronze.svg', name: 'Bronze' },
        unranked: {
          src: '/images/rank-unranked.svg',
          name: 'Sem classificação',
        },
      }
      return images[rank] || images.unranked
    },
    imageForRanking() {
      const images = [
        '/images/rank-gold.svg',
        '/images/rank-silver.svg',
        '/images/rank-bronze.svg',
      ]
      return images[this.position - 1] ?? '/images/rank-unranked.svg'
    },
  },
}
</script>

<style lang="sass" scoped>
.rankBadge
  border-radius: 1000px
  background: white
  border: 2px solid white
  box-shadow: 0 1px 2px 0px rgba(0,0,0,.1)
  position: relative
  display: flex
  align-items: center
  justify-content: center
  &:not(.mini)
    padding: 0 8px 0 12px
  &.unranked:not(.mini)
    padding: 0
  &-points
    white-space: nowrap
    color: rgba(0,0,0,.9)
    font-size: 12px
    padding: 0 6px
  &-image
    --padding: 10%
    height: calc(100% - (var(--padding) * 2))
    object-fit: fill
.badge-for-ranking
  background: #fff
  width: 20px
  height: 20px
  padding: 2px
  border-radius: 50%
  display: flex
  justify-content: center
  align-items: center
  box-shadow: 0 1px 2px 0px rgba(0,0,0,.1)
</style>
